import React, { useState } from 'react'
import PaymentsTabView from './ProjectPaymentTabView'
import PaymentFilters from '../components/ProjectPaymentFilters'
import ProjectPaymentCreationFormView from '../forms/ProjectPaymentCreationFormView'
import { Button } from 'react-bootstrap'

const ProjectPaymentsView = ({
  users,
  projectId,
  createPayment,
  isLoading,
  payments,
  totalElements,
  sorting,
  pagination,
  filters,
  handleFilterChange,
  handleClearFilters,
  handleSorting,
  handlePageSizeChange,
  handlePageChange
}) => {
  const [showCreateForm, setShowCreateForm] = useState(false);

  const handleSubmit = (data) => {
    createPayment(data);
  };

  return (
    <>
      <div>
        <div className='tw-my-4'>
          <Button
            className={!showCreateForm ? 'btn-info' : 'btn-danger'}
            onClick={() => {setShowCreateForm(prev => !prev)}}
          >
            {!showCreateForm ? 'Add a payment' : 'close'}
          </Button>
        </div>
        {showCreateForm && <ProjectPaymentCreationFormView
          users={users}
          projectId={projectId}
          handleSubmit={handleSubmit}
          />}
      </div>
      <div className='tw-border tw-border-solid tw-border-gray-200 tw-p-4 tw-mt-4 tw-rounded-lg'>
        <PaymentFilters
          filters={filters}
          handleFilterChange={handleFilterChange}
          handleClearFilters={handleClearFilters}
        />
      </div>
      { !!payments && <div>
      <PaymentsTabView
        projectId={projectId}
        isLoading={isLoading}
        payments={payments}
        totalElements={totalElements}
        sorting={sorting}
        pagination={pagination}
        handleSorting={handleSorting}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
      />
      </div> }
    </>
  );
};
export default ProjectPaymentsView;